module.exports = __webpack_public_path__ + "static/media/mom_daughter.5c9fb979.png";